.guideContainer {
	justify-content: center;
	align-items: flex-end;
	pointer-events: none;
	position: fixed;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
}

.guideWrapper {
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	min-width: 175px;
	pointer-events: none;
	position: absolute;
	top: 50px;
	bottom: 20px;
	right: 36px;
	left: 70px;
}

.guide {
	display: flex;
	pointer-events: all;

	&.full {
		flex-direction: column;
		width: 340px;
		max-width: 100%;
		height: 350px;
		max-height: 100%;
		border: 1px solid rgb(201, 186, 255);
		border-radius: 10px;
		border-image: initial;
		filter: drop-shadow(rgba(66, 41, 110, 0.3) 0px 0px 20px);
		overflow: hidden;
		/**
		 * The will-change property is used to inform the browser that the transform property of the element is likely to change in the future.
		 * Helps browser optimize rendering performance. Without this, when you drag the setup guide, it's "laggy"
		 */
		will-change: transform;
	}

	&.minimized {
		justify-content: center;
		align-items: center;
		gap: 4px;
		min-width: 165px;
		border: 1px solid transparent;
		border-radius: 300px;
		background: linear-gradient(270deg, #7662ce, #9054d5), linear-gradient(270deg, #6049be, #e1c8ff);
		background-clip: padding-box, border-box;
		background-origin: border-box;
		filter: drop-shadow(0 0 20px #9054d540) drop-shadow(0 0 10px #14044d33);
		will-change: transform;

		&:focus-visible {
			outline: 2px solid var(--focus-outline-color-dark);
			outline-offset: 2px;
		}
	}
}

.guideHeader {
	display: flex;
	align-items: center;
	cursor: pointer;
	width: 100%;
	justify-content: space-between;

	.full & {
		background-color: #f6f3ff;
		padding: 11px 0px 11px 10px;
	}

	.minimized & {
		gap: 4px;
		padding: 10px 0px 10px 16px;

		& svg {
			color: white;
		}
	}
}

.guideTitle:global(.MuiTypography-root) {
	font-size: 16px;
	font-weight: 500;
	color: #fff;

	.full & {
		font-size: 14px;
		text-align: left;
		color: #333333;
	}
}

.actionButtonContainer {
	display: flex;
	gap: 4px;
	padding-right: 8px;
	padding-left: 4px;
}

.actionButton {
	&.full {
		& svg {
			color: #6f6f6f;
		}
	}

	&.minimized {
		border-radius: 100%;
		background: #996ae1;
		width: 30px;
		height: 30px;
		& svg {
			color: white;
		}
		&&&&:hover {
			background-color: #7542c1;
		}
		&&&&:active {
			background-color: #612bb2;
		}
	}
}

.guideBody {
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding: 8px 10px 12px;
	background: linear-gradient(180deg, #fff, #f4eff9);
	overflow-y: auto;
	height: 100%;
}

.guideIntegrations {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.expandableContent {
	padding: 0 10px 6px 10px;
	display: flex;
	flex-direction: column;
	gap: 3px;
}

.expandableSection,
.integrationButton:global(.MuiButton-root),
.integrationButton {
	display: flex;
	flex-direction: column;
	border: 1px solid #eaeaea;
	border-radius: 8px;
	background-color: #fff;
	width: 100%;
}

.integrationButton:global(.MuiButton-root),
.integrationButton {
	display: flex;
	flex-direction: column;
	padding: 7px 10px;
	gap: 6px;

	&.selected {
		border-color: #42296e;
	}

	&.expandableButton {
		border: none;
		border-radius: inherit;
	}
}

.integrationButton:global(.MuiButton-root) {
	&:hover {
		background-color: #f4f4f4;

		&.selected {
			background-color: #faf6ff;
		}
	}

	&:focus-visible {
		outline: none;
		border: 1px solid var(--focus-outline-color-dark);
	}
}

.integrationButtonHeader {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
}

.integrationButtonTitle {
	display: flex;
	align-items: center;
	gap: 6px;

	& .subtitle {
		color: #333333;
		font-size: 12px;
		font-weight: 400;
		line-height: 1.6;
	}

	& .label {
		color: #333333;
		font-size: 14px;
		font-weight: 500;
		line-height: 1.6;
	}
}

.label:global(.MuiLink-root) {
	&:hover {
		text-decoration: none;
	}
}

.buttonDescription:global(.MuiTypography-root) {
	font-size: 13px;
	color: #333333;
	line-height: 1.6;
	text-align: left;
	font-weight: 400;
}

.integrationAction:global(.MuiButton-root) {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 4px 10px;
	font-size: 15px;
	font-weight: 500;
	color: #fff;
	background-color: #7762ce;
	border: 1px solid #845bd2;
	border-radius: 6px;
	width: 100%;

	&:hover {
		background-color: #7542c1;
	}
}

.footer {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 5px;
	margin-top: auto;
}

.statusIcon {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 18px;
	height: 18px;
	border-radius: 50%;
	flex-shrink: 0;

	&.completed {
		background-color: #008400;
	}

	&.notComplete {
		background: #f7f7f7;
		border: 1.5px dashed #8e8e8e;
	}
}

.progressBarSection {
	display: flex;
	flex-direction: column;
	gap: 14px;
	width: 100%;
}

.progressBarHeader {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;

	& .progressBarTitle {
		font-size: 14px;
		font-weight: 500;
		color: #000;
		line-height: 1.6;
	}

	& .progressBarChip {
		min-width: fit-content;
		height: 23px;
		font-size: 14px;
	}
}

.progressBar {
	width: 100%;
	height: 10px;
	background-color: #f2eeff;
	border-radius: 8px;
	overflow: hidden;
}

.progress {
	height: 100%;
	background-color: #8c77dd;
	border-radius: inherit;
}
